export default __webpack_public_path__ + "static/media/Rammy3.2e1baf93.jpg";